import { ServiceResult } from '../models/api-shared.models';
import { AreaFeaturePermissionSetting, UserSite } from '../models/site.models';
import ApiService from './api-service';

class SiteService extends ApiService {
  private static classInstance: SiteService;

  private constructor() {
    super('Site');
  }

  public getCurrentUserSite(): ServiceResult<UserSite> {
    return this.get(`${this.baseUrl}/GetCurrentUserSite`);
  }

  public getAreaFeaturePermissionSetting(customerId: string): ServiceResult<AreaFeaturePermissionSetting> {
    return this.get(`${this.baseUrl}/GetAreaFeaturePermission`, { customerId });
  }

  public verifyCaptcha(clientToken: string): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/VerifyCaptcha`, {
      ClientToken: clientToken,
      SiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    });
  }

  public static getInstance(): SiteService {
    if (!this.classInstance) {
      this.classInstance = new SiteService();
    }
    return this.classInstance;
  }
}

export default SiteService;
